var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-tags-input',{attrs:{"disabled":_vm.disabled,"tags":_vm.resultingTags},on:{"tags-changed":_vm.handleTagsChanged},model:{value:(_vm.tag),callback:function ($$v) {_vm.tag=$$v},expression:"tag"}})
}
var staticRenderFns = []

export { render, staticRenderFns }